import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { nameOf } from '../../../../../../../../../core/functions/string-helpers';
import { FormGroupType } from '../../../../../../../../../core/models/form-group-type';
import { maxAmountValidator } from '../../../../../../shared/validators/order-payment-validators';
import { PaymentTransactionConstants } from '../../../../../constants/payment-transaction-constants';
import { CreditPaymentFormMessages } from '../constants/credit-payment-form-messages';
import { CreditPaymentFormModel } from '../models/credit-payment-form-model';

@Injectable({
    providedIn: 'root',
})
export class CreditPaymentFormService {
    /**
     * Defines the structure of the credit payment form, including form controls and their validation rules.
     *
     * @returns A FormGroup configured for the credit payment form, with controls for amount and associated validators.
     */
    getFormDefinition(
        creditRemaining: number,
    ): FormGroup<FormGroupType<CreditPaymentFormModel>> {
        return new FormGroup<FormGroupType<CreditPaymentFormModel>>({
            amount: new FormControl<number | null>(
                PaymentTransactionConstants.MIN_PAYMENT_AMOUNT,
                [
                    Validators.required,
                    Validators.min(
                        PaymentTransactionConstants.MIN_PAYMENT_AMOUNT,
                    ),
                    maxAmountValidator(creditRemaining, {
                        label: nameOf<typeof CreditPaymentFormMessages>(
                            'amountExceedsCreditRemaining',
                        ),
                        message:
                            CreditPaymentFormMessages.amountExceedsCreditRemaining,
                    }),
                ],
            ),
        });
    }
}
